export const PUZZLE_PARAM = 'puzzle';
export const PUZZLE_BAND_PARAM = 'band';

export type PuzzleRatingBand = 'easy' | 'medium' | 'hard';

export type PuzzleDeepLinkBand = Exclude<PuzzleRatingBand, 'medium'>;

/** Direct link to one puzzle (always loads that ID; Next Puzzle returns to catalog). */
export function puzzleByIdPath(puzzleId: string): string {
  return `/puzzles/by-id/${encodeURIComponent(puzzleId)}`;
}

export function puzzlePlayPath(
  puzzleId: string,
  band?: PuzzleRatingBand,
): string {
  const params = new URLSearchParams();
  params.set(PUZZLE_PARAM, puzzleId);
  if (band && band !== 'medium') {
    params.set(PUZZLE_BAND_PARAM, band);
  }
  return `/puzzles?${params.toString()}`;
}

export function parsePuzzleSearch(search: string): string | null {
  const puzzleId = new URLSearchParams(search).get(PUZZLE_PARAM)?.trim();
  return puzzleId || null;
}

export function parsePuzzleBand(search: string): PuzzleRatingBand | null {
  const band = new URLSearchParams(search)
    .get(PUZZLE_BAND_PARAM)
    ?.trim()
    .toLowerCase();
  if (band === 'easy' || band === 'medium' || band === 'hard') {
    return band;
  }
  return null;
}

export function mergePuzzleSearchParams(
  prev: URLSearchParams,
  puzzleId: string | null,
): URLSearchParams {
  const next = new URLSearchParams(prev);
  if (puzzleId) {
    next.set(PUZZLE_PARAM, puzzleId);
  } else {
    next.delete(PUZZLE_PARAM);
  }
  next.delete(PUZZLE_BAND_PARAM);
  return next;
}
